import React from 'react';
import IconContainer from '../IconContainer';
import ClockIcon from 'images/icons/clock.svg?react-svg';

export default function Icon() {
  return (
    <IconContainer>
      <ClockIcon width={20} />
    </IconContainer>
  );
}
